import { render, staticRenderFns } from "./OnTimeDelivery.vue?vue&type=template&id=2582b3fd"
import script from "./OnTimeDelivery.vue?vue&type=script&lang=js"
export * from "./OnTimeDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports